import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';
import addressApi from '../../../../api/address';
import alertHelper from '../../../../helpers/alert';

const defaultState = () => ({
    provinces: [],
    city: [],
    districts: [],
    listAdress: [],
    selectedAddress: {}
});

const state = defaultState();

const mutations = {
    defineProvinces(state, data) {
        state.provinces = data;
    },
    defineCities(state, data) {
        state.city = data;
    },
    defineDistricts(state, data) {
        state.districts = data;
    },
    defineAddressList(state, data) {
        state.listAdress = data;
    },
    defineAddressSelected(state, data) {
        state.selectedAddress = data;
    },
    failed(state, { code, type, message }) {
        state.alerts = alertHelper.make(state.alerts, code, type, message);
    },
    reset(state) {
        Object.assign(state, defaultState());
    },
};

const actions = {
    getProvinces({ commit, dispatch }) {

        commit(PROGRESS_START, null, { root: true });

        addressApi.getProvinces().then(({ data: { data } }) => {
            commit('defineProvinces', data.results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getCity({ commit, dispatch }, code) {

        commit(PROGRESS_START, null, { root: true });

        addressApi.getCity(code).then(({ data: { data } }) => {
            commit('defineCities', data.results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getDistrict({ commit, dispatch }, code) {

        commit(PROGRESS_START, null, { root: true });

        addressApi.getDistrict(code).then(({ data: { data } }) => {
            commit('defineDistricts', data.results);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getAddressList({ commit, dispatch }, value) {

        commit(PROGRESS_START, null, { root: true });

        addressApi.getAddressList(value).then(({ data: { data } }) => {
            let indexDefault = data.results.findIndex(x => x.address_is_default == 1)
            commit('defineAddressSelected', data.results[indexDefault]);
            if (data.results == '') {
                commit('defineAddressList', 'error');
            } else {
                commit('defineAddressList', data.results);
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getAddressDetail({ commit, dispatch }) {

        commit(PROGRESS_START, null, { root: true });

        addressApi.getAddressDetail().then(({ data: { data } }) => {
            commit('defineAddressSelected', data);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    async submit({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        await addressApi.addAddress(value).then(() => {
            dispatch('getAddressList');
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    update({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        addressApi.updateAddress(value).then(() => {
            dispatch('getAddressList');
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    updateUtama({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        addressApi.utamaAddress({ id: value }).then(() => {
            dispatch('getAddressList');
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    deleteAddress({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        addressApi.deleteAddress({ id: value }).then(() => {
            dispatch('getAddressList');
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    selectAddress({ commit, state }, code) {
        let address = [...state.listAdress];
        let indexSelected = address.findIndex(x => x.address_id == code)
        let indexDefault = address.findIndex(x => x.address_is_default == 1)
        address[indexDefault].address_is_default = 0
        address[indexSelected].address_is_default = 1
        if (address == '') {
            commit('defineAddressList', 'error');
        } else {
            commit('defineAddressList', address);
        }
        commit('defineAddressSelected', address[indexSelected]);
    },
    errorHandler({ commit }, response) {
        commit('failed', { code: 'error_response', type: 'error', message: response.message });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};